import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "./images/ecash-logo-horizontal.png";

const Header = () => {
  const [modal, setModal] = useState(false);
  return (
    <div className="header-ctn">
      <div>
        <Link to="/">
          <h1>
            <img src={logo} alt="Scorecard" className="header-logo" />
            Scorecard
          </h1>
        </Link>
      </div>
      <div className="nav-ctn">
        <div className="navlink" onClick={() => setModal(true)}>
          About
        </div>
        <Link to="/withdrawals-working" className="navlink">
          Compare
        </Link>
        <a
          href="https://github.com/ecashxec/ecash-services/issues"
          target="_blank"
          rel="noreferrer"
          className="navlink"
        >
          Report an Issue
        </a>
        {modal && (
          <div
            className="modal-backdrop animate__animated animate__fadeIn"
            style={{
              width: "100%",
            }}
            onClick={() => setModal(false)}
          >
            <div
              className="modal-border animate__animated animate__fadeInUp"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-inner">
                <button
                  className="modal-close"
                  onClick={() => setModal(false)}
                  aria-label="Close modal"
                >
                  ×
                </button>
                Scorecard.cash highlights prominent eCash-supporting exchanges &
                services and scores them based on how well they adhere to the
                eCash standards. All exchanges & services should be using the
                correct branding, units (bits), and address format. Exchanges
                should also accept deposits within 1 block (about 5 minutes) and
                withdrawal fees should be low.
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
